export const checkLength = (query = '', length) => {
  const queries = query.split(' ');

  return queries.some((element) => element.length >= length);
};

export default checkLength;



// WEBPACK FOOTER //
// ./src/common/utils/checkLength.js